/**
 * Az adott böngésző támogatja a matchMedia-t?
 * Chrome: 9, Edge: 12, Safari: 5.1, FF: 6, Opera: 12, MÉG IE IS: 10.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia}
 */
export default function isSupported (): boolean {
  return 'matchMedia' in window
}
